import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import {
  fetchRevenueMatrix,
  fetchTeacherUtilisation,
  misCsvUrl
} from 'api/apartment'
import { Loading } from 'app/components/generic/LottieComponents'
import { formatAmount } from 'app/utils'

import ApartmentPageHeader from '../shared/ApartmentPageHeader'
import MonthFilter from '../shared/MonthFilter'

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  sectionTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1.5),
    fontWeight: 600
  }
}))

const ApartmentReports = () => {
  const classes = useStyles()
  const [matrix, setMatrix] = React.useState(null)
  const [teachers, setTeachers] = React.useState([])
  // '' = all time. Both endpoints already accepted ?month=; the page simply
  // never passed one, so every report was cumulative.
  const [month, setMonth] = React.useState('')

  React.useEffect(() => {
    let active = true
    setMatrix(null)
    fetchRevenueMatrix(month ? `?month=${month}` : '')
      .then((res) => active && setMatrix(res))
      .catch(() => active && setMatrix({ byCategory: [], byApartment: [] }))
    fetchTeacherUtilisation(month)
      .then((res) => active && setTeachers(res))
      .catch(() => active && setTeachers([]))
    return () => {
      active = false
    }
  }, [])

  if (!matrix) return <Loading />

  return (
    <div className={classes.root}>
      <ApartmentPageHeader
        title="Reports & MIS"
        showSelector={false}
        subtitle="All complexes"
        action={
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <MonthFilter value={month} onChange={setMonth} allowAll />
            <Button
              variant="outlined"
              size="small"
              href={misCsvUrl()}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download MIS (CSV)
            </Button>
          </div>
        }
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Revenue by category
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Category</TableCell>
                  <TableCell align="right">Collected</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {matrix.byCategory.map((c) => (
                  <TableRow key={c.category}>
                    <TableCell>{c.category}</TableCell>
                    <TableCell align="right">
                      {formatAmount(c.revenue)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Teacher utilisation
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Teacher</TableCell>
                  <TableCell align="right">Sessions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {teachers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>No sessions yet</TableCell>
                  </TableRow>
                ) : (
                  teachers.map((t) => (
                    <TableRow key={t.teacher}>
                      <TableCell>{t.teacher}</TableCell>
                      <TableCell align="right">{t.sessions}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  )
}

export default ApartmentReports
